/* DropLit typography: prevent dangling words at line breaks.
   CSS text-wrap can't stop a sentence's FIRST word stranding at a line end
   mid-paragraph, so we glue each sentence's first two words together (and the
   text's final pair) with non-breaking spaces. Same glyph width as a space,
   so nothing shifts visually — lines just break in better places. */
(function () {
  var SEL = 'p, .drop-card__tag, .odrop-card__tag, .vault-card__tag';
  var NB = '\u00A0';

  function fix(t) {
    if (!t || t.length < 8) return t;
    // Bind the first two words of the text
    t = t.replace(/^(\s*)(\S+)[ \t]+(?=\S)/, function (_, s, w) { return s + w + NB; });
    // Bind the first two words after each sentence end (. ! ? : …) or em dash
    t = t.replace(/([.!?:…—])([ \t]+)(\S+)[ \t]+(?=\S)/g, function (_, p, sp, w) { return p + sp + w + NB; });
    // Bind the last two words of the text
    t = t.replace(/[ \t]+(\S+)(\s*)$/, function (_, w, e) { return NB + w + e; });
    return t;
  }

  function walk(el) {
    for (var n = el.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3) {
        var v = fix(n.nodeValue);
        if (v !== n.nodeValue) n.nodeValue = v;
      } else if (n.nodeType === 1 && !/^(SCRIPT|STYLE|INPUT|TEXTAREA|SELECT|BUTTON)$/.test(n.tagName)) {
        walk(n);
      }
    }
  }

  function run() {
    document.querySelectorAll(SEL).forEach(walk);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
